import {Flag} from '@hconnect/uikit'
import {Typography} from '@mui/material'

export const LocationCellContent = ({
  name,
  countryCode,
  dataTestId
}: {
  name: string
  countryCode?: string
  dataTestId: string
}) => (
  <Typography
    component="span"
    display="inline-flex"
    alignItems="center"
    data-test-id={dataTestId}
    sx={{whiteSpace: 'normal', wordBreak: 'break-word'}}
  >
    {countryCode && (
      <Flag
        countryCode={countryCode}
        alt={name}
        height={18}
        sx={{
          verticalAlign: 'text-bottom',
          mr: 1
        }}
      />
    )}
    {name}
  </Typography>
)
